import React from 'react';
import { Snackbar as MuiSnackbar, Alert } from '@mui/material';

interface NotificationSnackbarProps {
  open: boolean;
  message: string;
  severity: 'error' | 'warning' | 'info' | 'success';
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
  autoHideDuration?: number;
  'data-testid'?: string;
}

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  open,
  message,
  severity,
  onClose,
  autoHideDuration = 6000,
  'data-testid': dataTestId,
}) => {
  return (
    <MuiSnackbar 
      open={open} 
      autoHideDuration={autoHideDuration} 
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        top: '20% !important',
        right: 'auto',
        maxWidth: '90%',
        transform: 'translate(-20%, -50%) !important',
      }}
      data-testid={dataTestId}
    >
      <Alert 
        onClose={onClose} 
        severity={severity} 
        sx={{ 
          width: '100%',
          minWidth: { xs: '250px', sm: '300px' },
          boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
        }}
      >
        {message}
      </Alert>
    </MuiSnackbar>
  );
};

export default NotificationSnackbar; 